import { LineProgressProps } from '@common/types/types';

export const sortByValueDescending = (arr: LineProgressProps[]): LineProgressProps[] => {
  return arr.sort((a, b) => b.value - a.value);
};

export const findMaxValue = (arr: LineProgressProps[]): number => {
  let maxValue = arr[0].value;
  for (let i = 1; i < arr.length; i++) {
    if (arr[i].value > maxValue) {
      maxValue = arr[i].value;
    }
  }
  return maxValue;
};
